var React = require('react');

function PreviousArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40 78.999C18.4609 78.999 0.999997 61.5381 0.999998 39.999C0.999999 18.4599 18.4609 0.99902 40 0.99902C61.5391 0.99902 79 18.4599 79 39.999C79 61.5381 61.5391 78.999 40 78.999ZM-1.74846e-06 39.999C-7.8281e-07 17.9076 17.9086 -0.000979277 40 -0.000978311C62.0914 -0.000980059 80 17.9076 80 39.999C80 62.0904 62.0914 79.999 40 79.999C17.9086 79.999 -2.7141e-06 62.0904 -1.74846e-06 39.999ZM47 39.1953L47 41.1953L40.5 41.1953L40.5 45.3913L33 40.1952L40.5 34.999L40.5 39.1953L47 39.1953Z","fill":"currentColor"}));
}

PreviousArrow.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = PreviousArrow;

PreviousArrow.default = PreviousArrow;
